export enum CompanyConfigPaths {
  TEMPLATES = '/templates',
  TEMPLATE_NUMERATION = '/numeration-template',
  SURCHARGE = '/surcharge',
  CONTRACT_FIELDS = '/contract-fields',
  CONTRACT_CONFIG = '/contract',
  CONTRACT_PAYMENT_TYPE = '/contract-payment-type',
  CONTRACT_ORDER = '/contract-order'
}
